
import { View } from 'backbone';
import Template from 'behaviors/properties/main/main-type.ejs';
//=====================================================================
//
// An instance of this view represents a type.
//
// Casey Justus, May 15, 2016
//
//=====================================================================

class MainTypeView extends View {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;


        this.events = {
            'change input[name="connectionType"]'   : 'updateAttributes'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal,{silent:true} );
    }



    render() {

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $(`input[value="${this.model.get('connectionType')}"]`).prop('checked',true);
        this.delegateEvents();
        return this;
    }

}

export default MainTypeView;
